import { ASSISTANTS  } from "../config/assistants";
import { MODELS } from '../config/models';
import { useChat } from "../contexts/ChatContext";
import React, { useEffect } from "react";

function AssistantSelector() {
    const { currentAssistant, setCurrentAssistant, selectedModel, setSelectedModel } = useChat();

    const userInfo  = JSON.parse( localStorage.getItem("userInfo") || "{}" );
    const roles     = JSON.parse( localStorage.getItem("userRoles") || "[]" );

    const visible = Object.entries(ASSISTANTS).filter( ([key, cfg]) => {
      const required = cfg.requiredRoles || [];
      return required.length === 0 || required.some( r => roles.includes(r) );
    });

    if(currentAssistant && !visible.find( ([k]) => k === currentAssistant ) && visible.length) {
      setCurrentAssistant( visible[0][0] );
    }

    useEffect(() => {
        if (currentAssistant) {
          const defaultModel = ASSISTANTS[currentAssistant]?.defaultModel || Object.keys(MODELS)[0];
          setSelectedModel(defaultModel);
        }
    }, [currentAssistant, setSelectedModel]);


    return (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
              {/* Assistant Dropdown */}
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">
                  Select Assistant:
                </label>
                <select
                  value={currentAssistant}
                  onChange={(e) => setCurrentAssistant(e.target.value)}
                  className="w-full p-2 border border-gray-300 rounded-md
                             bg-white text-black 
                             dark:bg-gray-700 dark:text-white dark:border-gray-600"
                >
                  { /*{Object.entries(ASSISTANTS).map(([key, config]) => ( */ }
                  {visible.map(([key, config]) => (
                    <option key={key} value={key}>
                      {config.name}
                    </option>
                  ))}
                </select>
                {
                  /*<div className="mt-1 text-xs text-gray-500 dark:text-gray-400">
                    {userInfo?.email || "demo@arccorp.com"} . Roles: { (roles || []).join(", ") || "none"}
                  </div>
                */
                }
              </div>
        
              {/* Model Dropdown */}
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">
                  Select Model:
                </label>
                <select
                  value={selectedModel}
                  onChange={(e) => setSelectedModel(e.target.value)}
                  className="w-full p-2 border border-gray-300 rounded-md
                             bg-white text-black 
                             dark:bg-gray-700 dark:text-white dark:border-gray-600"
                >
                  {Object.entries(MODELS).map(([key, config]) => (
                    <option key={key} value={key}>
                      {config.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
    )
}

export default AssistantSelector;